import {RANK_BY_ID} from '/enum/rank.enum';

import {formatRankText} from '../helpers/formatRankText.util';

export const RANK_DATA = Object.entries(RANK_BY_ID)
  .filter(([id]) => Number(id) <= 140)
  .sort((a, b) => Number(a[0]) - Number(b[0]))
  .map(([id, value]) => ({
    id: id.toString(),
    text: formatRankText(value as string),
  }));
